import { createFileRoute } from "@tanstack/react-router";
import AuthCallback from "@/pages/AuthCallback";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/auth/callback/")({
  head: () => routeHead("/uk/auth/callback/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthCallback />
  );
}
